import React, { useMemo } from 'react'

import InlineUserAvatars from './InlineUserAvatars'
import UserAvatar, { UserAvatarKind, UserAvatarSize } from './UserAvatar'

const MAX_AVATARS = 3

interface BasePerson {
  givenName?: string
  surname?: string
}

interface Props<T extends BasePerson> {
  people: T[]
  kind?: UserAvatarKind
  size?: UserAvatarSize
}

export default function UserAvatarGroup<T extends BasePerson>({
  people,
  kind = 'default',
  size = 'medium',
}: Props<T>) {
  const filteredPeople = useMemo(
    () =>
      people.length > MAX_AVATARS ? people.slice(0, MAX_AVATARS - 1) : people,
    [people],
  )

  if (people.length === 0) return null

  const notShownCount = people.length - filteredPeople.length

  return (
    <InlineUserAvatars>
      {filteredPeople.map((p, index) => (
        <UserAvatar
          key={index}
          variant="primary"
          content="user"
          firstName={p.givenName}
          lastName={p.surname}
          size={size}
          kind={kind}
        />
      ))}
      {notShownCount > 0 && (
        <UserAvatar
          variant="secondary"
          content="count"
          count={notShownCount}
          size={size}
          kind={kind}
        />
      )}
    </InlineUserAvatars>
  )
}
